import React from 'react';
import { t } from '@lingui/macro';
import styled from 'styled-components';

import { ReviewStar, ReviewStarFill, ReviewStarHalf } from '@rover/icons';
import { Color } from '@rover/kibble/styles';
import { useI18n } from '@rover/rsdk/src/modules/I18n';

export type Props = {
  className?: string;
  maxRating: number;
  rating: number;
};

export const SvgWrapper = styled.div`
  svg {
    fill: ${Color.YELLOW_400.toString()};
    width: 14px;
    height: 14px;
  }
`;

// These empty styled components are necessary for Enzyme to work
export const StyledReviewStarFill = styled(ReviewStarFill)``;
export const StyledReviewStarHalf = styled(ReviewStarHalf)``;
export const StyledReviewStar = styled(ReviewStar)``;

const StarRating = ({ maxRating, rating, ...other }: Props): JSX.Element => {
  const starsToMap = new Array(maxRating).fill(1);
  const { i18n } = useI18n();
  return (
    <SvgWrapper
      role="img"
      aria-label={i18n._(t`Rating: ${rating} out of ${maxRating} stars`)}
      {...other}
    >
      {starsToMap.map((_, i) => {
        const starType = rating - i;

        if (starType <= 0) {
          return <StyledReviewStar key={i} alt="" />;
        }

        if (starType > 0 && starType < 1) {
          return <StyledReviewStarHalf key={i} alt="" />;
        }

        return <StyledReviewStarFill key={i} alt="" />;
      })}
    </SvgWrapper>
  );
};

StarRating.defaultProps = {
  maxRating: 5,
};

export default StarRating;
